import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { put, select } from '@redux-saga/core/effects';
import {
  makeSelectCounterSelectedISInShelvesSelected,
  makeSelectIsSameIntermediateShelvesInShelvesSelected,
  makeSelectISSelection,
} from 'containers/IntermediateShelfPanel/selectors';
import { Position } from 'lib/modelBuilder/constants';
import { selectionIntermediateShelvesAction } from 'containers/IntermediateShelfPanel/actions';

export function* postSuccessAddIntermediateShelfSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  const { position } = payload;
  if (position) yield put(selectionIntermediateShelvesAction([position]));
  else yield put(selectionIntermediateShelvesAction());
}

export function* addIntermediateShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { height, position, color } = payload;
  for (const shelf of selectedShelves) {
    if (shelf.drawers.length === 0) {
      shelf.addIntermediateShelf(height, position, color);
    }
  }
  return {
    ignore: false,
    postSuccess: postSuccessAddIntermediateShelfSaga,
  };
}

export function* postSuccessRemoveIntermediateShelfSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  const counterIS = yield select(
    makeSelectCounterSelectedISInShelvesSelected(),
  );
  if (counterIS >= 1)
    yield put(selectionIntermediateShelvesAction([counterIS - 1]));
  else yield put(selectionIntermediateShelvesAction([]));
}

export function* removeIntermediateShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { all } = payload;

  if (all) {
    for (const shelf of selectedShelves) {
      for (const entryIS of shelf.intermediatesShelves) {
        shelf.removeIntermediateShelf([entryIS.position]);
      }
    }
    return {
      ignore: false,
      postSuccess: postSuccessRemoveIntermediateShelfSaga,
    };
  }

  const positions = yield select(makeSelectISSelection());
  if (positions.length === 0 || selectedShelves.length === 0)
    return { ignore: true };
  for (const shelf of selectedShelves) {
    shelf.removeIntermediateShelf(positions);
  }
  return {
    ignore: false,
    postSuccess: postSuccessRemoveIntermediateShelfSaga,
  };
}

export function* colorIntermediateShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { color } = payload;
  const selectionIS: number[] = yield select(makeSelectISSelection());
  const sameISNumber = yield select(
    makeSelectIsSameIntermediateShelvesInShelvesSelected(),
  );
  if ((selectionIS && selectionIS.length > 0) || !sameISNumber) {
    for (const shelf of selectedShelves) {
      let shelves = shelf.intermediatesShelves;
      if (sameISNumber) {
        shelves = shelves.filter(e => selectionIS.includes(e.position));
      }
      shelves.map(e =>
        e.updateIntermediateShelf(undefined, undefined, color, false),
      );
      shelf.updateSupportIS();
    }
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}

export function* depthIntermediateShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { value } = payload;
  const selectionIS: number[] = yield select(makeSelectISSelection());
  if (selectionIS && selectionIS.length > 0) {
    for (const selectedIndex of selectionIS) {
      for (const shelf of selectedShelves) {
        shelf.updateISDepth(value, selectedIndex);
      }
    }
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}

export function* heightIntermediateShelfSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { value } = payload;
  const selectionIS: number[] = yield select(makeSelectISSelection());
  if (selectionIS && selectionIS.length > 0) {
    for (const shelf of selectedShelves) {
      shelf.intermediatesShelves
        .filter(e => selectionIS.includes(e.position))
        .map(e => {
          e.updateSupportIntermediateShelf(Position.Left, value);
          e.updateSupportIntermediateShelf(Position.Right, value);
          e.updateSupportIntermediateShelf(Position.Back, value);
        });
    }
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}

export function* postSuccessPrepareIntermediateShelfSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  yield put(selectionIntermediateShelvesAction([0]));
}
